import fr from './locales/fr-FR'

export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'fr',
  messages: {
    fr
  }
}))
